import styled from 'styled-components';

export const Body = styled.div`
  overflow-x: hidden;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 40px;
  background: white;
`;

export const Back = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;

  .Backbutton {
    position: absolute;
    left: 20px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 20px;
    padding: 8px;
    display: flex;
    align-items: center;
  }

  .title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
`;

export const InfoContainer = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const InfoImg = styled.div`
  width: 60px;
  height: 60px;
  background-color: #E5E5E5;
  border-radius: 8px;
  flex-shrink: 0;
`;

export const Info = styled.div`
  flex: 1;
  text-align: left;
`;

export const InfoTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #333;
  margin-bottom: 4px;
  text-align: left;
`;

export const InfoLocation = styled.div`
  font-size: 14px;
  color: #666;
  text-align: left;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: #E5E5E5;
  margin: 0;
`;

export const DayTitle = styled.div`
  display: flex;
  align-items: center;
  padding: 20px;
  gap: 8px;

  .icon {
    font-size: 20px;
  }

  .title {
    font-weight: 600;
    font-size: 16px;
    color: #333;
  }
`;

export const CalContainer = styled.div`
  padding: 0 20px;
  margin-bottom: 30px;
`;

export const CalendarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .arrow {
    background: none;
    border: none;
    font-size: 18px;
    color: #333;
    cursor: pointer;
    padding: 8px;
  }

  .month-year {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
`;

export const CalendarWeekdays = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  margin-bottom: 12px;

  .weekday {
    text-align: center;
    font-size: 12px;
    color: #999;
    font-weight: 500;
  }
`;

export const CalendarDates = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
`;

export const DateCell = styled.div<{ isEmpty?: boolean; isSelected?: boolean; isPast?: boolean }>`
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: ${props => {
    if (props.isEmpty) return 'transparent';
    if (props.isPast) return '#CCC';
    if (props.isSelected) return '#333';
    return '#333';
  }};
  background-color: ${props => props.isSelected ? '#FFD700' : 'transparent'};
  border-radius: ${props => props.isSelected ? '50%' : '8px'};
  cursor: ${props => (props.isEmpty || props.isPast) ? 'default' : 'pointer'};
  font-weight: ${props => props.isSelected ? '600' : '400'};
  pointer-events: ${props => (props.isEmpty || props.isPast) ? 'none' : 'auto'};

  &:hover {
    background-color: ${props => !props.isEmpty && !props.isSelected && !props.isPast ? '#F5F5F5' : ''};
  }
`;

export const ConfirmButtonWrapper = styled.div`
  position: relative;
  width: calc(100% - 40px);
  margin: 20px 20px 0;
`;

export const GuestTooltip = styled.div<{ visible: boolean }>`
  position: absolute;
  bottom: calc(100% + 10px);
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  white-space: nowrap;
  pointer-events: none;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.2s;
  z-index: 10;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: rgba(0, 0, 0, 0.75);
  }
`;

export const ConfirmButton = styled.button<{ isGuestMode?: boolean }>`
  width: 100%;
  padding: 16px;
  background-color: #BBBBBB;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  color: #666;
  cursor: ${({ isGuestMode }) => isGuestMode ? 'not-allowed' : 'pointer'};
  transition: all 0.2s;

  &.active {
    background-color: #1FBC70;
    color: white;
  }
`;

export const TimeSection = styled.div`
  padding: 20px;
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .icon {
    font-size: 20px;
  }

  .title {
    font-weight: 600;
    font-size: 16px;
    color: #333;
  }
`;

export const TimeTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const LegendContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #666;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const TimeSlots = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TimeSlotButton = styled.button<{ isSelected?: boolean; isDisabled?: boolean; isCurrentReservation?: boolean }>`
  padding: 10px 20px;
  border-radius: 20px;
  border: ${props => props.isCurrentReservation ? '2px solid #1FBC70' : 'none'};
  font-size: 14px;
  font-weight: 500;
  cursor: ${props => (props.isDisabled || props.isCurrentReservation) ? 'not-allowed' : 'pointer'};
  transition: all 0.2s;
  background-color: ${props => {
    if (props.isCurrentReservation) return 'white';
    if (props.isDisabled) return '#E5E5E5';
    if (props.isSelected) return '#1FBC70';
    return '#F5F5F5';
  }};
  color: ${props => {
    if (props.isCurrentReservation) return '#1FBC70';
    if (props.isDisabled) return '#999';
    if (props.isSelected) return 'white';
    return '#333';
  }};
  opacity: ${props => (props.isDisabled && !props.isCurrentReservation) ? 0.5 : 1};

  &:hover {
    background-color: ${props => {
      if (props.isCurrentReservation) return 'white';
      if (props.isDisabled) return '#E5E5E5';
      if (props.isSelected) return '#1FBC70';
      return '#E5E5E5';
    }};
  }
`;

export const PersonSection = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PersonControl = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const PersonButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #E5E5E5;
  background-color: white;
  font-size: 18px;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background-color: #F5F5F5;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const PersonCount = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  min-width: 40px;
  text-align: center;
`;

export const AlarmSection = styled.div`
  padding: 20px;
`;

export const AlarmHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const AlarmToggle = styled.label`
  position: relative;
  width: 50px;
  height: 28px;
  display: inline-block;
  cursor: pointer;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.3s;
    border-radius: 28px;

    &:before {
      position: absolute;
      content: "";
      height: 20px;
      width: 20px;
      left: 4px;
      bottom: 4px;
      background-color: white;
      transition: 0.3s;
      border-radius: 50%;
    }
  }

  input:checked + .slider {
    background-color: #1FBC70;
  }

  input:checked + .slider:before {
    transform: translateX(22px);
  }
`;

export const AlarmOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const AlarmOptionButton = styled.button<{ isSelected?: boolean; isDisabled?: boolean }>`
  padding: 10px 20px;
  border-radius: 20px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: ${props => props.isDisabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s;
  background-color: ${props => {
    if (props.isDisabled) return '#E5E5E5';
    if (props.isSelected) return '#1FBC70';
    return '#F5F5F5';
  }};
  color: ${props => {
    if (props.isDisabled) return '#999';
    if (props.isSelected) return 'white';
    return '#333';
  }};
  opacity: ${props => props.isDisabled ? 0.5 : 1};

  &:hover {
    background-color: ${props => {
      if (props.isDisabled) return '#E5E5E5';
      if (props.isSelected) return '#1FBC70';
      return '#E5E5E5';
    }};
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 20px;
  max-width: 420px;
  width: calc(100% - 60px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  position: relative;
  overflow: hidden;
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: white;
  border: none;
  font-size: 28px;
  color: #333;
  cursor: pointer;
  padding: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 10;

  &:hover {
    background: #f5f5f5;
  }
`;

export const ModalHeader = styled.div`
  padding: 0;
  text-align: center;
  position: relative;
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 4px 0;
`;

export const ModalSubtitle = styled.p`
  font-size: 14px;
  color: white;
  margin: 0 0 16px 0;
  text-align: center;
`;

export const ModalImageContainer = styled.div`
  width: 100%;
  padding: 0;
  margin-bottom: 0;
`;

export const ModalImage = styled.img`
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 0;
  display: block;
`;

export const ModalInfoSection = styled.div`
  padding: 24px 24px 24px;
`;

export const ModalInfoTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
  text-align: left;
`;

export const ModalInfoLocation = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0 0 20px 0;
  text-align: left;
`;

export const ModalInfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 12px;
  gap: 8px;
`;

export const ModalInfoLabel = styled.span`
  font-size: 14px;
  color: #666;
`;

export const ModalInfoValue = styled.span`
  font-size: 14px;
  color: #FFA500;
  font-weight: 500;
`;

export const ModalButton = styled.button`
  width: calc(100% - 48px);
  margin: 0 24px 24px;
  padding: 16px;
  background-color: white;
  color: #1FBC70;
  border: 2px solid #1FBC70;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #f0fdf7;
  }
`;
